import { useEffect } from "react";
import { DelayedProps } from "./helper";
import { useToggle } from "../../helpers/functions/hooks";
import RenderIf from "../RenderIf";

const Delayed = ({ delay, children, fallback = <></> }: DelayedProps) => {
    const [isShown, setShown] = useToggle();

    useEffect(() => {
        setTimeout(() => {
            setShown();
        }, delay);
    // setShown will unnecessarily re-render the component if added in the dependency array
    // eslint-disable-next-line
    }, [delay]);

    return (
        <RenderIf condition={isShown} fallback={fallback}>
            {children}
        </RenderIf>
    );
}

export default Delayed;
